import React from 'react';
import { Navbar } from '../../components';
import { PeptHeader } from '../../containers';

const PerioperativeEP = () => {
  return (
    <div>
        <div className="gradient__bg">
          <Navbar />
          <PeptHeader />
        </div>
    </div>
  )
}

export default PerioperativeEP